import get from 'lodash-es/get';
import map from 'lodash-es/map';
import has from 'lodash-es/has';
import find from 'lodash-es/find';
import toString from 'lodash-es/toString';
import filter from "lodash-es/filter";
import isEmpty from "lodash-es/isEmpty";
import join from "lodash-es/join";
import set from "lodash-es/set";
import debounce from 'lodash-es/debounce';
const STATE = {};
class AddressTable {
  constructor(elem) {
    this.$block = $(elem);
    this.$pickup = this.$block.closest('.pickup');
    this.$more = this.$block.find('[data-read-more]');
    this.$empty = this.$block.find('.address-table__empty');
    this.$loader = this.$block.find('.address-table__loader');
    this.$switch = this.$pickup.find('.pickup__switch');
    this.$search = this.$block.find('.address-table__search');
    this.id = this.$block.data('id');
    this.action = this.$block.data('action-info');
    this.stores = [];
    this.$map = null;
    this.mapTab = this.$block.data('relatedMapTab');
    this.animated = false;
    this.filter = {};
    this.$block.addClass('init');
    if (this.mapTab) {
      this.$map = $(`#${this.mapTab}`).find('.map-available');
      this.$block.on('click', '[data-on-map]', this.onMap)
    }

    this.fetch().then(() => this.render()).finally(() => {
      this.$available = this.$block.find('.address-table__link_available');
      this.$notAvailable = this.$block.find('.address-table__link:not(.address-table__link_available)');
      this.$pickup.toggleClass('pickup_with_switch', this.$available.length > 0 && this.$notAvailable.length > 0);
      if (~window.location.hash.indexOf('#store')) {
        const id = window.location.hash.substring(6);
        AddressTable.setActive(id);
        if (window.matchMedia('(min-width:992px)').matches) {
          setTimeout(() => {
            const $target = $(`.address-table__link[data-id="${id}"]`);
            if ($target.get(0)) $target.get(0).scrollIntoView({ block: 'center' });
          }, 1500)
        }
      }
    });
    this.$more.on('click', () => this.$block.toggleClass('address-table_full'));
    this.$search && this.$search.on('input', (evt) => {
      debounce(() => this.updateFilter({ ADDRESS: evt.target.value }), 300)();
    });
    this.$switch.on('change', this.toggleAvailable);
    this.$block.on('shown.bs.collapse', () => {
      this.$block.one('hide.bs.collapse', () => {
        $('html, body').stop().animate({ scrollTop: this.$block.offset().top - 200 }, 350, () => this.$more.trigger('click'));
        return false;
      });
    });
  }
  fetch = () => new Promise((resolve) => {
    if (!this.action && window.Resellers) {
      this.stores = window.Resellers;
      resolve(this.stores);
    }
    else {
      const info = get(window, ['StoresInfo', join([this.id, this.action], '-')], []);
      if (!isEmpty(info)) {
        this.stores = info;
        resolve(this.stores);
      }
      else {
        const id = this.id;
        const sessid = window.BX ? window.BX.bitrix_sessid() : '';
        const current = new Date();
        const tomorrow = new Date(); tomorrow.setDate(new Date().getDate() + 1);
        $.ajax(this.action, {
          method: process.env.NODE_ENV === 'development' ? 'GET' : 'POST',
          dataType: 'json',
          data: { id, sessid },
        }).done((response) => {
          const items = get(response, ['result', 'items', this.id], []);
          const stores = get(response, 'result.storesInfo');
          this.stores = map(items.stores, ({ id, date }) => {
            const store = get(stores, id);
            const dateFormat = date;
            return Object.assign({
              id,
              coordinates: [ get(store, 'gpsN'), get(store, 'gpsS') ],
              address: get(store, 'address'),
              phone: get(store, 'phone'),
              time: get(store, 'schedule'),
              amount: get(store, 'amount'),
              inStock: dateFormat === current.toLocaleDateString(),
            }, date ? {
              date: dateFormat,
              order: dateFormat === current.toLocaleDateString(),
            }: {})
          });
          set(window, ['StoresInfo', join([this.id, this.action], '-')], this.stores)
          resolve(this.stores);
        })
      }
    }
  })
  apply = (json) => new Promise((resolve) => window.getBH((bh) => resolve(bh.apply(json))));
  getBlockHtml = (items) => {
    const active = ~window.location.hash.indexOf('#store') ? window.location.hash.substring(6) : null;
    return this.apply(map(items, ({ id, address, phone, inStock, time, amount }) => (
      {block: 'address-table', elem: 'body', content: [
          {cls: 'row m-n2', content: [
              {cls: 'col-auto py-2 pl-2 pr-0', content: [
                  {elem: 'mark', content: [
                      {block: 'fi', mods: {icon: 'mark'}, tag: 'i'}
                    ]},
                ]},
              {cls: 'col p-2', content: [
                  address && {elem: 'address', content: address},
                  time && {cls: 'font-size-middle text-lightgray', content: time},
                  phone && {elem: 'link', tag: 'a', cls: 'font-size-middle', attrs: {href: `tel:${phone}`}, content: phone},
                  inStock && {tag: 'b', cls: 'd-block', content: 'В наличии'}
                ]},
              {cls: 'col-auto p-2 d-flex flex-column align-items-end', content: [
                  this.mapTab && !isEmpty(this.$map) && {elem: 'on-map', attrs: {"data-on-map": id}, content: 'На карте'},
                  amount && {block: 'btn', cls: 'btn btn-primary mt-auto', attrs: {'data-action': 'fast', 'data-id': id}, content: 'Выбрать'}
                ]},
            ]},
        ]}
    )))
  };
  render = async () => {
    const stores = this.$block.hasClass('address-table_available') ? filter(this.stores, { inStock: true }) : this.stores;
    const filtered = filter(stores, (store) => {
      if (has(this.filter, 'ADDRESS')) {
        const address = this.filter['ADDRESS'];
        if (address && !new RegExp(address, 'ig').test(store.address)) return false;
      }
      if (has(this.filter, 'OPEN')) {
        const open = this.filter['OPEN'];
        if (open && open !== store.open) return false;
      }
      if (has(this.filter, 'MK')) {
        const mk = this.filter['MK'] === 'Y';
        return !(!mk && store.mk);
      }
      return true;
    });
    const points = filtered.length ? filtered : stores;
    const items = points.length ? points : this.stores;
    this.$block.find('.address-table__base').html(await this.getBlockHtml(items.slice(0, 4)));
    if(items.length > 4) this.$block.find('.address-table__collapse').html(await this.getBlockHtml(items.slice(4)));
    else this.$block.find('.address-table__collapse').html('');
    this.$more.toggleClass('d-none', items.length < 5);
    this.$switch.toggleClass('d-none', !find(this.stores, { inStock: false }) || !find(this.stores, { inStock: true }));
    this.$loader.remove();
    this.$block.find('[data-toggle="popover"]').popover({trigger: 'hover', placement: 'top'});
    this.$empty.toggleClass('d-none', !!items.length);
  };
  toggleAvailable = (event) => {
    this.$block.toggleClass('address-table_available', event.target.checked);
    this.render();
  };
  updateFilter = (json) => {
    this.filter = json;
    this.render();
  }
  onMap = (evt) => {
    const nav = this.$pickup.find(`[data-toggle="tab"][href="#${this.mapTab}"]`)
    const id = toString($(evt.target).data('onMap'));
    window.location.hash = `#store${id}`;
    nav.tab('show');
    this.$map.get(0).ins.$search.val(this.$search.val()).trigger('input');
  }
  static init() {
    $('.address-table:not(.init)').each((ind, elem) => {
      const ins = new AddressTable(elem);
      $(elem).data('address-table', ins);
    });
  }
  static setActive = (id) => {
    const $target = $(`.address-table__link[data-id="${id}"]`);
    $target.addClass('active');
    $(`.address-table__link:not([data-id="${id}"])`).removeClass('active');
  }
}

$(document).ready(() => AddressTable.init());
$(document).on('PageChange', () => AddressTable.init());

$(window).on('hashchange', () => {
  if (~window.location.hash.indexOf('#store')) {
    const id = window.location.hash.substring(6);
    AddressTable.setActive(id);
  }
});

window.Block = window.Block ? window.Block : {};
window.Block.AddressTable = AddressTable;
